import { ChakraProvider } from "@chakra-ui/provider";
import { extendTheme, FormControl, FormLabel, Input } from "@chakra-ui/react";

const activeLabelStyles = {
  transform: "scale(0.85) translateY(-24px)",
};

export const theme = extendTheme({
  components: {
    Form: {
      variants: {
        floating: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles,
              },
            },
            "input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label":
              {
                ...activeLabelStyles,
              },
            label: {
              top: 0,
              left: 0,
              zIndex: 2,
              position: "absolute",
              backgroundColor: "white",
              pointerEvents: "none",
              mx: 3,
              px: 1,
              my: 2,
              transformOrigin: "left top",
            },
          },
        },
      },
    },
  },
});

export function InputForm({ label, value, onChange, type, maxW = false }) {
  return (
    <ChakraProvider theme={theme}>
      <FormControl variant="floating">
        <Input
          focusBorderColor="#03a9f4"
          size="md"
          type={type}
          placeholder=" "
          value={value}
          onChange={onChange}
          maxW={maxW}
        />
        <FormLabel color="gray.400">{label}</FormLabel>
      </FormControl>
    </ChakraProvider>
  );
}
